import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import notifications from "./modules/notifications";
import chat from "./modules/chat";
import atendimento from "./modules/atendimento";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentDate: new Date(),
  },
  getters: {
    currentDate: (state) => state.currentDate,
  },
  mutations: {
    setCurrentDate(state) {
      state.currentDate = new Date();
    },
  },
  modules: { auth, notifications, chat, atendimento },
});
